import { useMemo } from 'react';
import { useGET } from '../shared/hooks';
import QueryString from '../../lib/QueryString';
import { getCombinationsReport } from './data/getCombinationsReport';

const toUrl = (seasonId, teamId, query) =>
  `/stats/season/${seasonId}/team/${teamId}/combos${query}`;

export function useCombinationExplorer(
  leagueId,
  seasonId,
  teamId,
  filters,
  possessions,
) {
  const query = createCombinationExplorerQueryString(
    leagueId,
    filters,
    possessions,
  );
  const url = toUrl(seasonId, teamId, query);
  const data = useGET(url);
  const report = useMemo(
    () =>
      data ? getCombinationsReport(data, possessions) : { hasData: false },
    [data, possessions],
  );
  return report;
}

/**
 * Combinations explorer has filters now, which are as follows
 * - games - List of string game ids, comma delimited
 * - players_on - List of string player ids, comma delimited
 * - players_off - List of string player ids, comma delimited
 * - is_clutch - Boolean (True/False) only look at clutch shifts
 * - is_final_two - Boolean (True/False) only look at shifts in the last 2 minutes
 * - is_garbage - Boolean (True/False) only look at garbage shifts
 * - periods - List of period numbers to include
 * - is_starting
 * - max_possessions - Max # of possessions
 * - min_possessions - Min # of possessions
 *
 * @see https://www.swingman.space/api/stats/season/1/team/64/combos?min_possessions=15&max_possessions=50&is_clutch=True
 * @see https://trello.com/c/fblZ2QXf/90-combination-explorer-filter
 */
function createCombinationExplorerQueryString(leagueId, filter, possessions) {
  const query = new QueryString();
  query.addValue('league_id', leagueId);

  // if (possessions && possessions.length === 2) {
  //   query.addValue('min_possessions', possessions[0]);
  //   query.addValue('max_possessions', possessions[1]);
  // }

  if (filter) {
    if (filter.period) {
      query.addArray('periods', filter.period.map(x => x.value));
    }
    if (filter.last2 === 'On') {
      query.addBoolean('is_final_two', true);
    } else if (filter.last2 === 'Off') {
      query.addBoolean('is_final_two', false);
    }

    if (filter.timeType === 'Clutch') {
      query.addBoolean('is_clutch', true);
    } else if (filter.timeType === 'Garbage') {
      query.addBoolean('is_garbage', true);
    }

    if (filter.rotation === 'Rotation') {
      query.addBoolean('is_starting', false);
    } else if (filter.rotation === 'Starter') {
      query.addBoolean('is_starting', true);
    }

    if (filter.division) {
      query.addValue('division', filter.division.toLowerCase());
    }

    if (filter.conference) {
      query.addValue('conference', filter.conference.toLowerCase());
    }
  }
  const queryString = query.toString();
  return queryString;
}
